import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_PrettyPrint_Comparison.scss';
import { _className } from '@nu-art/thunderstorm-frontend';
import { BadImplementationException, exists } from '@nu-art/ts-common';
import { PPDescription, PPIndicatorStatus } from '../../Component_PrettyPrint_Description/Component_PrettyPrint_Description.js';
const getComparisonToNumberTitle = (operator, value) => {
    switch (operator) {
        case 'eq':
            return `The following equals ${value}`;
        case 'neq':
            return `The following does not equal ${value}`;
        case 'gt':
            return `The following is greater than ${value}`;
        case 'gte':
            return `The following is greater than or equals ${value}`;
        case 'lt':
            return `The following is less than ${value}`;
        case 'lte':
            return `The following is less than or equals ${value}`;
    }
};
const getComparisonOperation = (operator) => {
    switch (operator) {
        case 'eq':
            return 'Equals to:';
        case 'neq':
            return 'Does not equal to:';
        case 'lt':
            return 'Is less than:';
        case 'lte':
            return 'Is equals or less than:';
        case 'gt':
            return 'Is greater than:';
        case 'gte':
            return 'Is equal or greater than:';
    }
};
const getStatus = (valueNode, interactive) => {
    if (!interactive)
        return;
    return typeof valueNode?.value === 'boolean'
        ? (valueNode.value ? PPIndicatorStatus.pass : PPIndicatorStatus.fail)
        : PPIndicatorStatus.dataNeeded;
};
export const Component_PrettyPrint_Comparison = (props) => {
    if (exists(props.valueNode) && props.valueNode.type !== 'comparison')
        throw new BadImplementationException(`ValueTree_Node type mismatch: expected "comparison", got "${props.valueNode.type}"`);
    const status = getStatus(props.valueNode, props.interactive);
    const className = _className('comparison-description', status);
    //Rendering for when we compare the left side to a constant number
    if (props.expression.rightHand.type === 'number') {
        const title = getComparisonToNumberTitle(props.expression.operator, props.expression.rightHand.value);
        return _jsxs(PPDescription, { className: className, children: [_jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsx(PPDescription.Title, { children: title })] }), _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.TreeLineConnector, {}), props.descriptorRenderer(props.expression.leftHand, props.valueNode?.left)] })] });
    }
    //Rendering for when we compare to dynamic expressions
    const operation = getComparisonOperation(props.expression.operator);
    return _jsxs(PPDescription, { className: className, children: [_jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsx(PPDescription.Title, { children: "The following:" })] }), _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.TreeLineConnector, {}), props.descriptorRenderer(props.expression.leftHand, props.valueNode?.left)] }), _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.Indicator, { status: status }), _jsx(PPDescription.Title, { children: operation })] }), _jsxs(PPDescription.Row, { children: [_jsx(PPDescription.TreeLineConnector, {}), props.descriptorRenderer(props.expression.rightHand, props.valueNode?.right)] })] });
};
//# sourceMappingURL=Component_PrettyPrint_Comparison.js.map